import React from 'react'

import Link from 'next/link'

import { FormattedMessage } from 'react-intl'
import Dialog, { Body } from 'components/dialog'
import css from './WarningModal.module.css'
import { useVisibility } from 'hooks/storage/session'

export const WarningModal = () => {
    const [visible, setVisible] = useVisibility('archive-warning-modal', true)

    const close = () => {
        setVisible(false)
    }

    return (
        <Dialog open={visible} insetWindowPadding="20%">
            <Body>
                <div className={css.Body}>
                    <h1>
                        <FormattedMessage
                            defaultMessage="Warning"
                            description="Forecast archive warning modal"
                        />
                    </h1>
                    <p>
                        <FormattedMessage
                            defaultMessage="Forecasts displayed on this page are <b>not current</b>. You are viewing historical data."
                            values={{
                                b: (...chunks) => <strong>{chunks}</strong>,
                            }}
                            description="Forecast archive warning modal"
                        />
                    </p>
                </div>
            </Body>
            <footer className={css.Footer}>
                <Link href="/">
                    <a className={css.Live}>
                        <FormattedMessage
                            defaultMessage="Take me to the live forecast"
                            description="Forecast archive warning modal"
                        />
                    </a>
                </Link>
                <button onClick={close} className={css.Button}>
                    <FormattedMessage
                        defaultMessage="Continue to the forecast archive"
                        description="Forecast archive warning modal"
                    />
                </button>
            </footer>
        </Dialog>
    )
}
